// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__MdwI0","expandIcon":"AccordionButton_expandIcon__2SrWz","expanded":"AccordionButton_expanded__3UU0t"};